import api from './api';

// --- Master Data ---
export const getMasterRoles = () => api.get('roles');
export const getMasterPermissions = () => api.get('permissions');
export const getPropertyAreas = () => api.get('property-areas/role');
